import axios from "axios";
import { toast } from "react-toastify";
import { GET_PERSONALISE_QUESTIONS, GET_USER_IS_FROM_BETA_PRODUCT, GET_USER_UUID, SET_PERSONALISE_ANALYSIS } from "./types";
import { axiosAuth } from "../../config/axiosInstances";
import { API_XANO_BASE_URL } from "../../config/api_config";
import { Api_url } from "../../common/api_url";

export function fetchIsUserFromBetaProduct(successCallback, errorCallback){
    return async function(dispatch) {
        try {
            const response = await axiosAuth.get('https://xgfy-czuw-092q.m2.xano.io/api:HYL0rVog/user/beta_details')
            dispatch({ type: GET_USER_IS_FROM_BETA_PRODUCT, payload: response.data?.data })
            successCallback && successCallback(response?.data)
        } catch (error) {
            errorCallback && errorCallback(error)
        }   
    }
}

export function fetchUserUUID(name, email, phone_number, skill_name, successCallback, errorCallback){
    return async function(dispatch) {
        try {
            const response = await axios.post('https://ninjacurate.learntube.ai/onboarding_id', {
                name: name,
                email: email,
                phone_number: phone_number,
                skill_name: skill_name
            })
            dispatch({ type: GET_USER_UUID, payload: response.data })
            successCallback && successCallback(response.data)
        }catch (err){
            console.log(err)
            toast.warning('something went wrong')
            errorCallback && errorCallback(err)
        }
    }
}

export function fetchUnqiueUserUUID(name, email, phone_number,skill_name, successCallback, errorCallback){
    return async function(dispatch) {
        try {
            const response = await axios.post('https://ninjacurate.learntube.ai/mobile_app/creation_id', {
                name: name,
                email: email,
                phone_number: phone_number,
                skill_name 
            })
            dispatch({ type: GET_USER_UUID, payload: response.data })
            successCallback && successCallback(response.data)

        }catch (err){
            console.log(err.message)
            toast.warning(err.message)
            errorCallback && errorCallback(err)
        }
    }
}

export function fetchQuestions(uid, skill_name, skill_difficulty, successCallback, errorCallback){
    return async function(dispatch) {
        try {
            const response = await axios.post('https://ninjacurate.learntube.ai/q_generation_onboarding', {
                uid: uid,
                skill_name: skill_name,
                skill_difficulty: skill_difficulty
            })
            dispatch({ type: GET_PERSONALISE_QUESTIONS, payload: response.data })
            successCallback && successCallback(response.data)
        }catch (err) {
            console.log(err.message)
            toast.warning(err.message)
            errorCallback && errorCallback(err)
        }
    }
}

export function fetchAnalysis(uuid, subject, questions, correct_answers, user_answers, score){
    return async function (dispatch){
      const maxRetries = 3;
      let retries = 0;
      while (retries < maxRetries) {
        try {
            const response = await axios.post('https://certified-backend.learntube.ai/mcq_analysis', {
                user_id:uuid, subject: subject, questions: questions, correct_answers: correct_answers, user_answers: user_answers
            })
            return dispatch({ type: SET_PERSONALISE_ANALYSIS, payload: { analysis: response.data, score: score }})
        } catch (e) {
            console.log(e.message)
            retries += 1;
        }
    }
    toast.error('Error in fetching analysis. Please try again later.')}
}

export function fetchPaymentId(uuid, amount, productName, successCallback, errorCallback) {
    return async function (dispatch){
        try {
            const response = await axios.post("https://xgfy-czuw-092q.m2.xano.io/api:IfQi_Nyx/razorpay_ninjacurate_payment/create_order", {
                uid: uuid,
                amount: amount,
                product_name: productName
            })
            successCallback && successCallback(response.data)
        }catch (error){
            console.log(error.message)
            errorCallback && errorCallback(error.message)
        }
    }
}

export function dispatchUserPersonaliseCourseSelection(personaliseCoursePurchased, successCallback, errorCallback){
    return async function(){
        try {
            const response = await axiosAuth.post(API_XANO_BASE_URL + Api_url.PostUserPersonaliseCourseSelection, {
                personaliseCoursePurchased
            })
            console.log(response.data);
            successCallback && successCallback(response.data)
        }catch (error){
            console.log(error.message);
            errorCallback && errorCallback(error.message)
        }
    }
}

export function fetchRazorPayStatus ({ uuid, payment_id, order_id, isError, razorpay_signature, errorObj }){
    return async function(){
        try {
            console.log('this is from dispatch function', uuid, payment_id, order_id, isError, razorpay_signature)
            const response = await axios.post("https://xgfy-czuw-092q.m2.xano.io/api:ZZCtun0K/payment_status",
                {
                    uid: uuid,
                    payment_id:payment_id, 
                    order_id:order_id, 
                    isError:isError, 
                    razorpay_signature:razorpay_signature, 
                    errorObj:errorObj
                }
            )
            console.log(response.data)
        }catch(error){
            console.log(error.message)
        }
    }   
}

export function saveSkillName(uuid, subject, successCallback, errorCallback){
    return async function(){
        try{
            const response = await axios.post("https://xgfy-czuw-092q.m2.xano.io/api:ZZCtun0K/save_onbaording_odd_subject", 
            {
                uuid: uuid,
                subject: subject
            })
            successCallback && successCallback(response.data)
        }catch(error){
            console.log(error.message)
            errorCallback && errorCallback(error.message)
        }
    }
}
